var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('nav', {
    staticClass: "gh-nav"
  }, [_c('div', {
    staticClass: "gh-accordion"
  }, [_c('accordion-item', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('products-and-services-links')];
      },
      proxy: true
    }])
  }, [_c('span', [_vm._v("Products and Services")])]), _vm.showDiscoveryTool ? _c('accordion-item', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('discovery-tool-integration', {
          attrs: {
            "environment": _vm.environment
          }
        })];
      },
      proxy: true
    }], null, false, 1839223713)
  }, [_c('div', [_c('icon-compass', {
    staticClass: "gh-icon gh-compass"
  }), _vm._v(" Discover Content ")], 1)]) : _vm._e()], 1), _c('div', {
    staticClass: "gh-popovers"
  }, [_vm.showDiscoveryTool ? _c('popover', {
    attrs: {
      "id": "gh-discoverContentPopover",
      "popover-name": "discoverContentPopover",
      "custom-class-trigger": "gh-popoverTrigger",
      "right-alignment": true,
      "width": 800,
      "min-width": 600
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('discover-content', {
          attrs: {
            "environment": _vm.environment
          }
        })];
      },
      proxy: true
    }], null, false, 3643261850)
  }, [_c('icon-compass', {
    staticClass: "gh-icon gh-compass"
  }), _vm._v(" Discover Content ")], 1) : _vm._e(), _c('popover', {
    attrs: {
      "id": "gh-productsAndServicesPopover",
      "popover-name": "productsAndServicesPopover",
      "custom-class-trigger": "gh-popoverTrigger",
      "right-alignment": true,
      "width": 800,
      "min-width": 600
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('products-and-services')];
      },
      proxy: true
    }])
  }, [_vm._v(" Products and Services ")])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };